import type { AppDrawerType, VendorDrawerType } from '@main/shared/utils';
import { filterObjNullable } from '@main/shared/utils';

type QueryParams =
  | ({
      platform: 'app';
    } & AppDrawerType)
  | ({
      platform: 'vendor-portal';
    } & VendorDrawerType);

export const getLinkQueryParams = (object: QueryParams) => {
  const { platform: _, ...rest } = object;

  const filtered = filterObjNullable(rest);
  const stringified = Object.fromEntries(
    Object.entries(filtered).map(([key, value]) => [key, String(value)]),
  );

  return new URLSearchParams(stringified).toString();
};
